'use client';

import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import initAnimation from './animations/bg-video-animation';
import { fetchImage2Base64 } from '@/lib/utils/utils';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';

// 配置参数，如需要可以改成入参
const REMOTE_FIRST_FRAME_OF_BG_VIDEO_URL = getStaticAssetUrl(
    '/generate_video/00000.jpg',
);

const DEFAULT_BG_COLOR = '#6f7d8f';

function BgVideo() {
    const rootRef = useRef<HTMLDivElement>(null);
    const bgCanvasRef = useRef<HTMLCanvasElement>(null);

    useGSAP(
        () => {
            let cleanupAnimation: (() => void) | undefined;
            let disposed = false;

            fetchImage2Base64(REMOTE_FIRST_FRAME_OF_BG_VIDEO_URL).then(
                (base64) => {
                    if (disposed) return;

                    const firstImg = new Image();
                    firstImg.src = base64;
                    firstImg.onload = () => {
                        if (disposed) return;

                        const canvas = bgCanvasRef.current;
                        if (!canvas) return;
                        const ctx = canvas.getContext('2d');
                        if (!ctx) return;

                        ctx.drawImage(
                            firstImg,
                            0,
                            0,
                            canvas.width,
                            canvas.height,
                        );
                    };
                    cleanupAnimation = initAnimation(
                        rootRef.current!,
                        bgCanvasRef.current!,
                    );
                },
            );

            return () => {
                disposed = true;
                cleanupAnimation?.();
            };
        },
        { scope: rootRef },
    );

    return (
        <div
            ref={rootRef}
            style={{
                zIndex: -999,
                backgroundColor: DEFAULT_BG_COLOR,
                height: 'var(--simulaix-vh, 100svh)',
            }}
            className="fixed left-0 top-0 w-full"
        >
            <canvas
                ref={bgCanvasRef}
                className="h-full w-full bg-contain bg-center bg-no-repeat object-cover"
            />
        </div>
    );
}

export default BgVideo;
